import React, { useState, useEffect } from 'react';
import { 
  Settings, ShieldCheck, Headset, 
  LogOut, CreditCard, CheckCircle, Mail,
  History // Naya icon import kiya
} from 'lucide-react';
import { ref, onValue } from "firebase/database";
import { db } from "../firebase"; 
import { useNavigate } from "react-router-dom"; 
import Swal from 'sweetalert2'; 
import './Mine.css';

const Mine = () => {
  const navigate = useNavigate(); 
  const [userData, setUserData] = useState({
    username: "Trader",
    balance: "0.00",
    email: "user@gmail.com"
  });

  useEffect(() => {
    const savedUser = JSON.parse(localStorage.getItem('user'));
    
    if (savedUser && savedUser.username) {
      const userRef = ref(db, 'users/' + savedUser.username);
      const unsub = onValue(userRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setUserData({
            username: data.username || "Trader",
            balance: data.balance || "0.00",
            email: data.email || savedUser.email || "N/A" 
          });
        }
      });
      return () => unsub(); 
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    window.location.href = "/login";
  };

  // Security Center Detail Logic
  const openSecurity = () => {
    Swal.fire({
      title: 'Security Center',
      html: `
        <div style="text-align: left; font-size: 13px;">
          <p><b>• Cold Wallet Storage:</b> 98% of user assets are stored in offline multi-sig wallets.</p>
          <p><b>• 2FA Verification:</b> All withdrawals require mandatory email/SMS verification.</p>
          <p><b>• Encryption:</b> AES-256 bank-grade encryption protects your personal data.</p>
          <p><b>• Anti-Phishing:</b> Real-time monitoring of suspicious login attempts from new IPs.</p>
        </div>
      `,
      icon: 'info',
      confirmButtonText: 'Understood',
      confirmButtonColor: '#00b894'
    });
  };

  return (
    <div className="mine-container-v2">
      <div className="mine-header">
        <div className="header-top">
          <h3>Profile</h3>
          <div className="header-icons" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
            {/* History Icon Added here */}
            <History 
              size={22} 
              className="history-icon" 
              onClick={() => navigate('/history', { state: { activeTab: 'mine' } })} 
              style={{ cursor: 'pointer', color: '#333' }}
            />
            <Settings 
              size={22} 
              className="settings-icon" 
              onClick={() => navigate('/settings', { state: { activeTab: 'mine' } })} 
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
        
        <div className="profile-card">
          <div className="avatar-circle">
            {userData.username.substring(0, 2).toUpperCase()}
          </div>
          <div className="user-info" style={{ textAlign: 'left', flex: 1, marginLeft: '12px' }}>
            <h4 style={{ margin: 0, fontSize: '18px' }}>Hi, {userData.username}</h4>
            <p style={{ 
              display: 'flex', 
              align: 'center', 
              gap: '4px', 
              fontSize: '12px', 
              margin: '4px 0 0 0',
              color: '#666'
            }}>
              <Mail size={12} /> {userData.email}
            </p>
          </div>
          <div className="verify-badge">
            <CheckCircle size={14} style={{ marginRight: '4px' }} />
            Verified
          </div>
        </div>
      </div>

      <div className="assets-card">
        <div className="asset-label">Total Balance (USDT)</div>
        <div className="asset-amount">
          {parseFloat(userData.balance).toFixed(2)}
        </div>
        <div className="asset-actions">
          <button className="btn-dep" onClick={() => navigate('/deposit', { state: { activeTab: 'mine' } })}>
            Deposit
          </button>
          <button className="btn-wit" onClick={() => navigate('/withdraw', { state: { activeTab: 'mine' } })}>
            Withdraw
          </button>
        </div>
      </div>

      <div className="menu-section">
        <div className="menu-item" onClick={() => navigate('/payment-method', { state: { activeTab: 'mine' } })}>
          <div className="menu-icon-wrapper" style={{ backgroundColor: '#fff9e6' }}>
            <CreditCard size={20} color="#f3ba2f" />
          </div>
          <span>Payment Methods</span>
        </div>
        
        <div className="menu-item" onClick={openSecurity}>
          <div className="menu-icon-wrapper" style={{ backgroundColor: '#e6fffa' }}>
            <ShieldCheck size={20} color="#00b894" />
          </div>
          <span>Security Center</span>
        </div>
        
        <div className="menu-item" onClick={() => navigate('/service', { state: { activeTab: 'mine' } })}>
          <div className="menu-icon-wrapper" style={{ backgroundColor: '#eef2ff' }}>
            <Headset size={20} color="#4f46e5" />
          </div>
          <span>Customer Support</span>
        </div>
        
        <div className="menu-item logout" onClick={handleLogout}>
          <div className="menu-icon-wrapper" style={{ backgroundColor: '#fff1f2' }}>
            <LogOut size={20} color="#e11d48" />
          </div>
          <span style={{ color: '#e11d48', fontWeight: '500' }}>Log Out</span>
        </div>
      </div>
      
      <div className="bottom-nav-spacer"></div>
    </div>
  );
};

export default Mine;